const SubSourceType = {
  BRAND_ITEMS: 'brand-items',
  SAVE_FOR_LATER: 'save-for-later',
  SIMILAR_ITEMS: 'similar-items',
  WTWI: 'ways-to-wear-it',
};

export default SubSourceType;
